import { PropsWithChildren } from 'react';
import { Typography } from '@shipengine/giger';
import { getSubHeaderStyles, getSubHeaderTitleStyles } from './SubHeaderStyles';

type SubHeaderProps = {
    title: string;
};

export function SubHeader({ title, children }: PropsWithChildren<SubHeaderProps>): JSX.Element {
    return (
        <section css={getSubHeaderStyles}>
            <Typography css={getSubHeaderTitleStyles} variant="heading3" component="h3">
                {title}
            </Typography>

            {children}
        </section>
    );
}
